//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatTimeStr } from '@/utils/index'

const getTimeStr = (time) => {
    const formated_time = formatTimeStr(time)
    if (formated_time) {
        return `距离登记结束还有：${formated_time}`
    }
    return ''
}
export default {
    data () {
        return {
            reg_tip: '该楼盘正在登记中，请注意登记截止时间哟~',
            task: 0,
            clock_end: false
        }
    },
    props: {
        visit_reservation_url: {
            type: String,
        },
        ln_status: {
            type: String
        },
        house: {
            type: Object
        },
        ln_register_end_time: {
            type: String
        }
    },
    beforeDestroy () {
        this.resetTask()
    },
    watch: {
        ln_register_end_time (ln_register_end_time) {
            console.log(this.house)
            if (this.house.status === '正在登记' && this.ln_status === '正在登记' && (this.house.zone_level < 3 || this.house.building_id === 750)) {
                this.changeRegTip(ln_register_end_time.replace(/-/g, '/'))
            }
        }
    },
    methods: {
        resetTask () {
            this.task && clearTimeout(this.task)
        },
        changeRegTip (ln_register_end_time) {
            const spare_time = new Date(ln_register_end_time).getTime() - new Date().getTime()
            console.error(12423, spare_time)
            this.resetTask()
            if (spare_time > 0) {
                this.reg_tip = getTimeStr(spare_time)
                this.runClock(spare_time)
            } else {
                this.clock_end = true
            }
        },
        runClock (spare_time) {
            this.task = setTimeout(() => {
                if (spare_time > 1000) {
                    spare_time -= 1000
                    this.reg_tip = getTimeStr(spare_time)
                    this.runClock(spare_time)
                } else {
                    this.clock_end = true
                    this.resetTask()
                }
            }, 1000)
        }
    }
}
